<template>
  <div>
    <div class="flex flex-col">
      <div
        ref="contentRef"
        class="flex-1 prose prose-sm"
        v-html="content"
        :class="[isExpanded ? '' : `line-clamp-${rows}`]"
      />
      <div v-if="needsExpand" class="flex justify-end items-center">
        <button class="btn btn-xs btn-ghost" @click.stop="toggle">
          {{ isExpanded ? collapseText : expandText }}
        </button>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import i18n from "@/locales";
import { ref, onMounted, watch, nextTick, onUnmounted } from "vue";

defineProps({
  class: {
    type: String,
    default: "",
  },
  content: {
    type: String,
    required: true,
  },
  rows: {
    type: Number,
    default: 1,
  },
  expandText: {
    type: String,
    default: i18n.global.t("Buttons.expand"),
  },
  collapseText: {
    type: String,
    default: i18n.global.t("Buttons.collapse"),
  },
});

const isExpanded = ref(false);
const needsExpand = ref(false);
const contentRef = ref<HTMLElement | null>(null);

const checkOverflow = () => {
  if (!contentRef.value) return;
  const lineHeight = parseInt(getComputedStyle(contentRef.value).lineHeight);
  const maxHeight = lineHeight * 5; // 5行的高度
  needsExpand.value = contentRef.value.scrollHeight > maxHeight;
};

const toggle = () => {
  isExpanded.value = !isExpanded.value;
};

// 监听内容变化
watch(
  () => contentRef.value,
  () => {
    if (contentRef.value) {
      nextTick(checkOverflow);
    }
  },
  { immediate: true }
);

onMounted(() => {
  window.addEventListener("resize", checkOverflow);
});

// 组件卸载时移除事件监听
onUnmounted(() => {
  window.removeEventListener("resize", checkOverflow);
});
</script>
